<script>
	import { links } from 'svelte-routing';
    import { _, locale } from 'svelte-i18n';
    import { onMount } from 'svelte';

    //let toggled = false;
    let flag_src = "";
    let lang = "";

    onMount(() => {
        if (document.documentElement.lang.startsWith('sv')) {
            flag_src = "img/flag_sv.svg";
            lang = $_('header.lang_sv');
        } else {
            flag_src = "img/flag_en.svg";
            lang = $_('header.lang_en');
        }
    })

    const switchLocale = () => {
        if (document.documentElement.lang == 'sv') {
            flag_src = "img/flag_en.svg";
            lang = $_('header.lang_en');
            locale.set('en');
        } else {
            flag_src = "img/flag_sv.svg";
            lang = $_('header.lang_sv');
            locale.set('sv');
        }
    }

    // The toggleAccess function is to change contrasting colors on the site with a click.
    // We'll remove this function for now, but keep it commented here to see how similar fixes can be done easily.
    // In global.css the three colors have been replaced by the ones with higher contrast.
    /*const toggleAccess = () => {
        toggled = !toggled

        if (toggled) {
            document.documentElement.style.setProperty("--colorFg", "#12394A");
            document.documentElement.style.setProperty("--colorElement", "#205F6F");
            document.documentElement.style.setProperty("--colorElementVariant", "#3D808A");
        } else {
            document.documentElement.style.removeProperty("--colorFg");
            document.documentElement.style.removeProperty("--colorElement");
            document.documentElement.style.removeProperty("--colorElementVariant");
        }
    }*/
</script>

<style>
    .header {
        padding: var(--spacingLarge) var(--spacingXLarge);
        width: 100%;
        /*position: fixed;*/
    }
    .header-content {
        max-width: 1000px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    a {
        text-decoration: none;
        flex: 1;
    }
    .title {
        font-family: var(--typeFaceVariant);
        font-size: var(--typeSizeXLarge);
        color: var(--colorElement);
        line-height: 1.7;
    }
    .title::first-letter {
        color: var(--colorFg)
    }
    
    .language img {
        width: 12vw;
        max-width: 80px;
        min-width: 40px;
        cursor: pointer;
    }

    /*.access-button {
        width: 10vw;
        height: 10vw;
        max-width: 40px;
        max-height: 40px;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: var(--spacingLarge);
        background-color: var(--colorElement);
        cursor: pointer;
    }

    .access-button img {
        max-width: 70%;
        margin-top: var(--spacingXSmall);
    }

    .access-button.toggled {
        background-color: var(--colorFg);
    }*/

    @media screen and (max-width: 470px) {
     .title {
        font-size: var(--typeSizeLarge);
     }
    }


</style>

<div class="header">
    <div class="header-content">
        <a href="/" on:click use:links>
            <div class="title">{$_('header.title')}</div>
        </a>
        <!-- <div title={$_('header.toggle_access')} class="access-button" class:toggled on:click={toggleAccess}><img alt="knapp med glasögon" src='img/glasses_white.svg'></div>-->
        <!-- The above button has been hidden for now and higher contrast has been inmplemented as standard. See more comments in script section. -->
        <div class="language" on:click={switchLocale}><img title="{$_('header.language')}: {lang}. {$_('header.flag_click')}" alt="{$_('header.flag_alt')}: {lang}. {$_('header.flag_click')}" class=flag src={flag_src} /></div>
    </div>
</div>

